export default "__VITE_ASSET__CxDJBxxW__"